/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.recommendModule')
.controller('RecommendController', ['BulbRecommendService', RecommendController]);

/**
 * Controller to manage the recommends in the header.
 */
function RecommendController(BulbRecommendService) {

  /**
   * How many recommendations to retrieve with each RESTful request
   * @type {number}
   */
   var PAGE_SIZE = 10;
  /**
   * All retrieved recommended units.
   * @type {Object}
   */
  this.recommends = BulbRecommendService.recommends;

  /**
   * @type {boolean} Whether the initial set of recommends has been fetched or not.
   */
  this.initialRecommendsFetched = false;

  /**
   * Gets the first page of recommends of the current active unit type.
   */
  this.getInitialRecommends = function() {
    if (!this.initialRecommendsFetched) {
      this.getNextPage();
      this.initialRecommendsFetched = true;
    }
  };

  /**
   * Gets the next page of recommends.
   * @param unitType The type of recommends to fetch.
   */
  this.getNextPage = function() {
    return BulbRecommendService.fetchRecommends(PAGE_SIZE);
  };
}


